import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
import{erpplatserver} from '@/utils/baseUrl';
import{sse_url} from '@/utils/baseUrl';

//关闭SSE
export async function closeSSE(params) {
    return post(sse_url+'/closeSSE', params, true);
}


// 获取公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}

//保存列表
//saveCarryOver;
export async function saveCarryOver(params) {
    return post(erpserver+'/sell/saveCarryOver', params, true);
}

//公司列表
//getCbJsList;
export async function getCbJsList(params) {
    return post(erpserver+'/sell/getCbJsList', params, true);
}

//完结
export async function carryOverEnd(params) {
    return post(erpserver+'/sell/carryOverEnd', params, true);
}

//结转
export async function carryOver(params) {
    return post(erpserver+'/sell/carryOver', params, true);
}

//获取进度条列表
export async function getCarryOverList(params) {
    return post(erpserver+'/sell/getCarryOverList', params, true);
}

//获取成本结转时间
export async function getCbJsTime(params) {
    return post(erpserver+'/sell/getCbJsTime', params, true);
}

//获取未结转时间
export async function getJsTime(params) {
    return post(erpserver+'/sell/getJsTime', params, true);
}

//获取下月销售开票列表
export async function getSellInvoiceNextList(params) {
    return post(erpserver+'/sell/getSellInvoiceNextList', params, true);
}

//更新下月销售开票状态
export async function updSellInvoiceNext(params) {
    return post(erpserver+'/sell/updSellInvoiceNext', params, true);
}

//获取销售开票列表
export async function getSellInvoiceList(params) {
    return post(erpserver+'/sell/getSellInvoiceList', params, true);
}

//更新销售开票状态
export async function updSellInvoice(params) {
    return post(erpserver+'/sell/updSellInvoice', params, true);
}

//获取内部交易列表
export async function getInSellList(params) {
    return post(erpserver+'/sell/getInSellList', params, true);
}

//更新内部交易状态
export async function updInSell(params) {
    return post(erpserver+'/sell/updInSell', params, true);
}